import React from 'react';

export default function SaveIcon() {
	return (
		<svg
			width='14'
			height='12'
			viewBox='0 0 14 12'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M12.9062 0.875C13.0625 0.75 13.2812 0.75 13.4375 0.875L13.7812 1.25C13.9375 1.375 13.9375 1.625 13.7812 1.78125L4.40625 11.1562C4.28125 11.2812 4.03125 11.2812 3.90625 11.1562L0.1875 7.4375C0.03125 7.28125 0.03125 7.03125 0.1875 6.90625L0.53125 6.53125C0.6875 6.40625 0.90625 6.40625 1.0625 6.53125L4.15625 9.625L12.9062 0.875Z'
				fill='white'
			/>
		</svg>
	);
}
